import React from "react";

const About = () => {
  return (
    <section
      id="about"
      aria-label="Perfil"
      className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8"
    >
      <header className="mb-4">
        <h2 className="text-xl md:text-2xl font-semibold tracking-tight font-poppins text-slate-900">
          Perfil
        </h2>
        <p className="mt-2 text-sm md:text-base text-slate-600 leading-relaxed">
          Desarrolladora fullstack apasionada por crear 
experiencias web inmersivas y funcionales, con +2 años 
de experiencia en frontend (Angular, TypeScript, 
Tailwind CSS, Angular Material) y backend (Python 
Flask, Java Spring boot). He liderado el diseño y 
despliegue de aplicaciones responsive que optimizan 
flujos de usuario, integrando servicios gratuitos como 
Firebase para autenticación y hosting en proyectos 
comunitarios (e.g., portales deportivos y de mayoristas 
y proyectos empresariales y usuarios mensuales). 
manejode cloud (AWS Lambda/ DynamoDB/ S3, 
Firebase) para arquitecturas serverless escalables sin 
costos iniciales, y en integración de IA (Azure AI, AWS 
SageMaker) para chatbots interactivos y 
automatizaciones inteligentes. Comprometida con 
accesibilidad WCAG 2.1 AA
        </p>
      </header>

      <ul className="mt-5 space-y-2 text-sm md:text-base">
        <li className="flex items-start gap-3 text-slate-700">
          <span className="mt-2 h-1.5 w-1.5 rounded-full bg-slate-400" aria-hidden="true" />
          <span>
            <strong className="text-slate-900 font-medium">+2 años</strong> construyendo aplicaciones responsivas y
            soluciones serverless orientadas a producto.
          </span>
        </li>

        <li className="flex items-start gap-3 text-slate-700">
          <span className="mt-2 h-1.5 w-1.5 rounded-full bg-slate-400" aria-hidden="true" />
          <span>
            Integración de <strong className="text-slate-900 font-medium">IA</strong> (Azure AI, AWS SageMaker) y
            cumplimiento de <strong className="text-slate-900 font-medium">WCAG 2.1 AA</strong>.
          </span>
        </li>
      </ul>
    </section>
  );
};

export default About;
